import { type SxProps, type Theme } from '@mui/system';

export const loginSx: SxProps<Theme> = {
  position: 'relative',
  background: '#444654',
  padding: '40px 32px 52px 32px',
  width: {
    sm: 'auto',
    md: '600px',
    lg: '700px',
  },
  margin: '0px 30px',
  boxShadow: '0px 3px 6px #00000029',
  borderRadius: '10px',
  '& .bi': {
    fontSize: '24px',
    '&.bi-eye, &.bi-eye-slash': {
      cursor: 'pointer',
    },
  },
  '& .title': {
    fontSize: {
      sm: '18px',
      md: '26px',
      lg: '28px',
    },
    lineHeight: '34px',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#ffffff',
    paddingBottom: '15px',
    borderBottom: 'solid 2px #707070',
    marginBottom: '36px',
  },
  '& button': {
    width: '200px',
    fontSize: '18px',
    lineHeight: '40px',
    padding: 0,
    textTransform: 'none',
    borderColor: '#ffffff',
    color: '#ffffff',
  },
  '& .error-msg': {
    color: 'red',
    marginTop: '12px',
    fontSize: '18px',
    textAlign: 'center',
    lineHeight: '22px',
  },
  '& .logo': {
    display: 'block',
    textAlign: 'center',
    marginBottom: '25px',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: '100px',
    opacity: 1,
  },
  '& .askRegister': {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '20px',
    textAlign: 'center',
    font: 'normal normal normal 15px/28px Roboto',
    letterSpacing: '0px',
    color: '#707070',
  },
  '& .regist': {
    paddingLeft: '5px',
    textDecoration: 'underline',
    color: '#ffffff',
    cursor: 'pointer',
  },
  '& .validInfo': {
    width: '85%',
    marginLeft: '7.5%',
    marginBottom: '28px',
    textAlign: 'left',
    font: 'normal normal normal 15px/18px Roboto',
    letterSpacing: '0px',
    color: '#ffffff',
    opacity: 1,
  },
};

export const labelSx: SxProps<Theme> = {
  width: '85%',
  marginLeft: '7.5%',
  marginBottom: '11px',
  color: '#009869 !important',
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 'bold',
  transform: 'none',
};

export const textSx: SxProps<Theme> = {
  width: '85%',
  marginLeft: '7.5%',
  marginBottom: '38px',
  '& .MuiInput-root': {
    marginTop: '36px',
    paddingLeft: '27px',
    paddingRight: '18px',
    '&::before, &::after': {
      borderColor: '#ffffff !important',
    },
  },
  '& label': {
    color: '#ffffff !important',
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: 'bold',
    transform: 'none',
  },
  '& input': {
    color: '#ffffff',
    fontSize: '18px',
    lineHeight: '22px',
  },
};

export const selectSx: SxProps<Theme> = {
  ...textSx,
  '&::before, &::after': {
    borderColor: '#009869 !important',
  },
  '& .MuiSelect-select': {
    marginLeft: '60px',
    lineHeight: '22px',
  },
};

export const iconSelectSx: SxProps<Theme> = {
  '& .bi': { position: 'absolute', left: { xs: '50px', md: '65px', lg: '75px' } },
};

export const footerSx: SxProps<Theme> = {
  margin: {
    sm: '30px 30px 0px',
    md: '60px 30px 0px',
    lg: '105px 30px 0px',
  },
  fontSize: '12px',
  width: {
    sm: 'auto',
    md: '600px',
    lg: '700px',
  },
  '& .remarks': {
    color: '#009869',
    lineHeight: '16px',
    marginTop: '15px',
    fontWeight: 'bold',
  },
  '& .remarkContent': {
    fontStyle: 'italic',
    color: '#707070',
    lineHeight: '16px',
  },
  '& .disclaimer': {
    fontWeight: 'bold',
    color: '#009869',
    lineHeight: '14px',
    margin: '16px 0px 6px',
  },
  '& .disclaimerContent': {
    color: '#707070',
    lineHeight: '14px',
  },
};

export const registSx: SxProps<Theme> = {
  width: '85%',
  marginLeft: '7.5%',
  marginBottom: '11px',
  '& .MuiInput-root': {
    marginTop: '36px',
    paddingLeft: '27px',
    paddingRight: '18px',
    '&::before': {
      borderColor: '#ffffff !important',
    },
    '&::after': {
      borderColor: '#ffffff',
    },
    '&.Mui-error:after': {
      borderColor: '#d32f2f !important',
    },
  },
  '& label': {
    color: '#ffffff !important',
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: 'bold',
    transform: 'none',
  },
  '& input': {
    color: '#ffffff !important',
    WebkitTextFillColor: '#ffffff !important',
    fontSize: '18px',
    lineHeight: '22px',
  },
};

export const userDialogSx: SxProps<Theme> = {
  '& .error-msg': {
    color: 'red',
    padding: '0 0 0 155px',
    fontSize: '16px',
    height: '26px',
  },
  '& .bi-x': {
    position: 'absolute',
    right: '15px',
    cursor: 'pointer',
    color: '#707070',
    fontSize: '35px',
    fontWeight: 'bold',
    padding: '10px',
  },
  '& .MuiPaper-root': {
    margin: {
      xs: '6px',
      md: '32px',
    },
    minWidth: {
      xs: '360px',
      lg: '800px',
    },
  },
  '& .MuiDialogContent-root': {
    padding: '12px',
  },
  '& label': {
    color: '#006EC2',
    fontSize: '18px',
    fontWeight: 'bold',
    marginRight: {
      xs: '12px',
      md: '24px',
    },
    minWidth: '125px',
    textAlign: 'right',
  },
  '& .MuiOutlinedInput-input': {
    padding: '7px 16px',
    color: '#000000',
    fontSize: '18px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#006EC2',
  },
  '& .checkbox-label': {
    fontSize: '18px',
    minWidth: {
      xs: 'auto',
      md: '140px',
    },
    display: 'inline-block',
    textTransform: 'capitalize',
  },
  '& .MuiCheckbox-root': {
    padding: '0px 9px',
  },
  '& .confirm-row': {
    fontSize: '25px',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  '& .ok-login': {
    justifyContent: 'center',
    display: 'block',
    textAlign: 'center',
    color: '#707070',
    fontSize: '15px',
    font: 'normal normal normal 15px/28px Roboto',
  },
  '& .MuiDialogActions-root': {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '50px',
    '& .Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      background: 'rgba(0, 0, 0, 0.12)',
    },
    '& .error-msg': {
      color: 'red',
      marginTop: '12px',
    },
  },
  '& button': {
    backgroundColor: '#009869',
    width: '250px',
    fontSize: '18px',
    lineHeight: '40px',
    padding: 0,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#78C8AF',
    },
  },
};
